/**
 * Provides vertex semantics utility functionality
 * @class VertexSemantic
 */
export class VertexSemantic {
    constructor(vertexSemantic) {
        this.index = -1;
        this.vertices = [];
        this.colors = [];
        this.normals = [];
        this.hasIndex = false;
        this.hasColor = false;
        this.hasNormal = false;
        this.hasVertex = false;
        let count = 0;
        let i = 0;
        let timeOut = 0;
        while (i < vertexSemantic.length && timeOut < vertexSemantic.length) {
            switch (vertexSemantic[i]) {
                case "v":
                    for (let j = 0; j < +vertexSemantic[i + 1]; j++) {
                        this.vertices.push(count);
                        count++;
                    }
                    i += 2;
                    this.hasVertex = true;
                    break;
                case "c":
                    for (let j = 0; j < +vertexSemantic[i + 1]; j++) {
                        this.colors.push(count);
                        count++;
                    }
                    i += 2;
                    this.hasColor = true;
                    break;
                case "n":
                    for (let j = 0; j < +vertexSemantic[i + 1]; j++) {
                        this.normals.push(count);
                        count++;
                    }
                    i += 2;
                    this.hasNormal = true;
                    break;
                case "i":
                    this.index = count;
                    i += 1;
                    this.hasIndex = true;
                    break;
            }
            timeOut++;
        }
    }
}
//# sourceMappingURL=vertexsemantic.js.map